/**
 * Favicon theme switcher - updates favicon based on prefers-color-scheme (dark/light)
 * Loaded with defer after theme config. Must run after DOM is ready.
 */
(function() {
  'use strict';
  var darkModeIcon = 'https://cdn.shopify.com/s/files/1/0870/1008/3081/files/Juno_Pets_Light_Favicon_Dog_Supplement.png?v=1765500570';
  var lightModeIcon = 'https://cdn.shopify.com/s/files/1/0870/1008/3081/files/Juno_Pets_vet_Formulated_Vet_Developed.png?v=1764266408';

  function updateFavicon() {
    var isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    var favicon = document.querySelector("link[rel='icon']:not([media])") ||
                  document.querySelector("link[rel='icon']") ||
                  document.createElement('link');

    if (!favicon.hasAttribute('rel')) {
      favicon.setAttribute('rel', 'icon');
      favicon.setAttribute('type', 'image/png');
      document.head.appendChild(favicon);
    }

    favicon.href = isDarkMode ? darkModeIcon : lightModeIcon;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFavicon);
  } else {
    updateFavicon();
  }

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateFavicon);
  }
})();
